import { Journey } from 'src/common/interfaces/journey.interface';
import { Nullable } from 'src/types/nullable.type';
import { apiGetThumbnailEmbedUrl } from 'src/utils/journeyApi';
import { create } from 'zustand';
import { shareThumbnailCodeGetTemplate } from './get-template';

interface Variables {
  thumbnailElement: Nullable<JSX.Element>;
  requestInProgress: boolean;
}

interface Methods {
  generateThumbnailCode: (uuid: Journey['uuid'], url: string) => Promise<void>;
  resetThumbnailElement: () => void;
}

type StoreState = Variables & Methods;

const initialState: Variables = {
  thumbnailElement: null,
  requestInProgress: false,
};

export const useShareThumbnailCodeStore = create<StoreState>((set, get) => ({
  ...initialState,
  generateThumbnailCode: async (uuid, url) => {
    const { resetThumbnailElement } = get();
    resetThumbnailElement();
    set({ requestInProgress: true });
    const { embed_thumbnail_url } = await apiGetThumbnailEmbedUrl(uuid);
    const reactElement = shareThumbnailCodeGetTemplate(url, embed_thumbnail_url);
    set({ thumbnailElement: reactElement, requestInProgress: false });
  },
  resetThumbnailElement() {
    set(initialState);
  },
}));
